import { Component } from '@angular/core';
import { Router } from '@angular/router';

import { Locale, LocaleDataService } from '../../core';

@Component({
  selector: 'atn-locale-data-switcher',
  templateUrl: './locale-data-switcher.component.html',
  styleUrls: ['./locale-data-switcher.component.scss']
})
export class LocaleDataSwitcherComponent {
  locales: Array<Locale>;
  currentLocale: Locale;

  constructor(
    private router: Router,
    private localeDataService: LocaleDataService
  ) {
    this.locales = this.localeDataService.getLocalesAvailable();
    this.currentLocale = this.localeDataService.getCurrentLocale();
  }

  onChange(locale: Locale) {
    this.localeDataService.setLocale(locale.code);
    location.reload();
  }
}


// WEBPACK FOOTER //
// ./libs/atenea-cms/src/layout/locale-data-switcher/locale-data-switcher.component.ts